function PlantDetailModal({ plant, onClose }) {

  if (!plant) return null
  
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short', 
      day: 'numeric'
    })
  }
  
  return (
    <div 
      className="modal-overlay"
      onClick={() => onClose()}
    >
      <div 
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          className="modal-close"
          onClick={() => onClose()}
        >
          ✕
        </button>

        <div className="modal-header">
          <span className="modal-plant-icon">{plant.icon}</span>
          <div className="modal-plant-info">
            <h2 className="modal-plant-name">{plant.name}</h2>
            <p className="modal-plant-type">{plant.type}</p>
          </div>
        </div>

        <div className="modal-details">
          <div className="detail-item">
            <span className="detail-label">Watering Schedule</span>
            <span className="detail-value">
              {`Every ${plant.frequencyDays} days`}
            </span>
          </div>
          
          <div className="detail-item">
            <span className="detail-label">Last Watered</span>
            <span className="detail-value">
              {formatDate(plant.lastWatered)}
            </span>
          </div>
        </div>

        <div className="care-history">
          <h3 className="history-title">
            <span>📅</span> Care History
          </h3>
          
          <div className="history-list">
            {plant.careHistory.length === 0 ?(
              <p className="history-empty">No Watering History yet</p>
            ): (
              plant.careHistory.map((date, index) => (
                <div key={index} className="history-item">
              <span className="history-icon">💧</span>
              <span className="history-date">{formatDate(date)}</span>
            </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PlantDetailModal